import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=dark%20cinematic%20movie%20theater%20interior%20with%20warm%20glowing%20red%20and%20gold%20ambient%20lighting%2C%20elegant%20velvet%20curtains%2C%20abstract%20bokeh%20lights%20effect%2C%20luxurious%20atmosphere%2C%20professional%20cinematography%20quality%2C%20deep%20shadows%20with%20rich%20warm%20highlights&width=1920&height=1080&seq=niuniu-hero-bg&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/70" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white mb-4 tracking-wide">
          牛牛影视
        </h1>
        <p className="text-base md:text-xl text-white/80 mb-3 max-w-2xl">
          牛牛超清 · 不缓冲流畅播放 · 沉浸式追剧观影
        </p>
        <p className="text-sm md:text-base text-white/60 mb-8 max-w-xl">
          牛牛极清模式下畅享高清电影、电视剧全集免费在线观看，告别卡顿
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/movie"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-medium text-sm whitespace-nowrap transition-all duration-200 cursor-pointer"
          >
            开始观影
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white rounded-full font-medium text-sm whitespace-nowrap transition-all duration-200 backdrop-blur-sm cursor-pointer border border-white/20"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex items-center gap-6 md:gap-10">
          {[
            { value: '10万+', label: '影视资源' },
            { value: '5000万+', label: '累计用户' },
            { value: '4K', label: '牛牛极清' },
            { value: '99.9%', label: '不缓冲率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-3xl font-bold text-white">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}